import React from 'react';
const PinIcon = props => React.createElement("svg", Object.assign({
  width: "11",
  height: "8",
  viewBox: "0 0 11 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M7.20656 6.20744C6.4267 7.48358 4.5733 7.48357 3.79344 6.20744L0 0L11 0L7.20656 6.20744Z",
  fill: "var(--color-neutral-90)"
}), React.createElement("path", {
  d: "M6.49562 7.3708C6.04695 8.10499 4.95305 8.10499 4.50438 7.3708L0 0L11 0L6.49562 7.3708Z",
  fill: "var(--color-neutral-90)"
}));
export default PinIcon;